<div class="rescue-page">
    <img class="rescue-shield" src="../../../assets/images/rescuemii-shield.png" alt="RescueMII">
    <h1>RescueMII&trade; Support</h1>
    <p class="text-center text-muted">We&rsquo;re here to help.</p>

    <!-- AC-4598: still open: whether RescueMII gets its
         own terms instead of the domii license linked below. -->

    <p><strong>In a life-threatening emergency, call 911.</strong> RescueMII&trade; alerts the people you choose, but it
        is not a replacement for emergency services.</p>

    <h2>Contact us</h2>
    <p>Email <a href="mailto:support@domii.io">support@domii.io</a> or call <a href="tel:+18663664446">1-866-366-4446</a>.
        Please include the email address on your account and your phone model. Our support hours are 8 am to 5 pm
        Eastern Time.</p>

    <h2>Getting started</h2>
    <h3>How do I sign up?</h3>
    <p>Tap the invitation link you received, then install RescueMII from the App Store or Google Play. On Android your
        invitation comes with you; on iPhone, tap the invitation link again once the app is installed. You can also sign up
        on the web from the same link.</p>
    <h3>My invitation code doesn&rsquo;t work.</h3>
    <p>Invitation codes can expire or be used only once. Ask the person who invited you to send a new invitation, or
        continue without one.</p>
    <h3>Who should I add as emergency contacts?</h3>
    <p>Add 2 to 5 people who have agreed to be contacted for you and who can act quickly, using their mobile numbers.</p>

    <h2>Using RescueMII</h2>
    <h3>How do I activate RESCUE hands-free?</h3>
    <p>On iPhone, say &ldquo;Hey Siri, Activate RescueMII&rdquo;. On Android, turn on your voice prompts in the app
        (My Account &rarr; My Voice Prompts), then say &ldquo;Activate RescueMII&rdquo;. &ldquo;Activate RescueMII
        Alarm&rdquo;, &ldquo;Capture&rdquo; and &ldquo;Record&rdquo; start those tools the same way.</p>
    <h3>Why does RescueMII need my location?</h3>
    <p>So your emergency contacts can keep following your live location after RESCUE is activated, even when your phone
        is locked. On iPhone this needs location access &ldquo;Always&rdquo;; on Android, access &ldquo;while using the
        app&rdquo; is enough. You can change this in your phone&rsquo;s settings at any time.</p>
    <h3>Why does it need my camera and microphone?</h3>
    <p>For CAPTURE and RECORD, which send photos, videos and audio to your emergency contacts, and on Android to listen for
        your voice prompts.</p>
    <h3>I&rsquo;m not getting alerts.</h3>
    <p>Check that notifications are allowed for RescueMII in your phone&rsquo;s settings and that you are signed in. If
        it still doesn&rsquo;t work, contact us.</p>

    <h2 id="delete-account">Delete your account</h2>
    <p>In the app, go to My Account &rarr; My Settings &rarr; Delete Account and follow the steps. If you can&rsquo;t use the app, email <a href="mailto:support@domii.io">support@domii.io</a> from
        the email address on your account and ask us to delete it. We will confirm once it is done. Deleting your account
        removes your profile and emergency contacts; see our <a routerLink="/rescue/privacy">Privacy Policy</a> for what we
        may keep and why. Memberships bought through the App Store or Google Play must be cancelled there.</p>

    <h2>Policies</h2>
    <ul>
        <li><a routerLink="/rescue/privacy">Privacy Policy</a></li>
        <li><a href="https://ia9incextra.blob.core.windows.net/blob/mobile_app_eula_v4.html" target="_blank"
                rel="noopener">License Agreement</a></li>
    </ul>
</div>
<app-footer></app-footer>
